import React from "react";
import PropTypes from "prop-types";
import Linkify from "react-linkify";
//Material imports
import Typography from "@mui/material/Typography";
import withStyles from "@mui/styles/withStyles";
import Fade from "@mui/material/Fade";
//Limitless imports
import { withi18n } from "../../hocs/i18n";
const SystemDialogue = ({
  t,
  classes,
  shouldAnimate,
  body,
  dialogueClasses,
  Icon,
  showRightIcon = true
}) => {
  const allClasses = {
    ...classes,
    ...dialogueClasses
  };
  return /*#__PURE__*/React.createElement(Fade, {
    in: true,
    appear: shouldAnimate
  }, /*#__PURE__*/React.createElement("div", {
    className: allClasses.infoDialogueContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: `${allClasses.infoDialogueBody} ${allClasses.primaryBackground}`
  }, Icon, /*#__PURE__*/React.createElement(Linkify, {
    properties: {
      target: "_blank",
      onClick: e => e.stopPropagation()
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    className: allClasses.primaryText,
    component: "span",
    tabIndex: 0
  }, /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: t(body)
    }
  }))), showRightIcon && Icon)));
};
const styles = () => ({
  infoDialogueContainer: {
    display: "flex",
    flex: "1",
    flexDirection: "column",
    paddingTop: 10,
    paddingBottom: 10
  },
  infoDialogueBody: {
    wordWrap: "break-word",
    wordBreak: "break-word",
    fontSize: 16,
    lineHeight: "1.333",
    padding: 13,
    marginLeft: "10%",
    marginRight: "10%",
    textAlign: "center",
    flexDirection: "row",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  }
});
export default withStyles(styles)(withi18n(SystemDialogue));
SystemDialogue.propTypes = {
  body: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  shouldAnimate: PropTypes.bool.isRequired,
  dialogueClasses: PropTypes.object.isRequired,
  Icon: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  showRightIcon: PropTypes.bool
};